<div id="main-wrapper">
    <app-header></app-header>
    <app-siderbar [Navegacion]="Navegacion"></app-siderbar>
    <div class="page-wrapper">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <router-outlet (activate)="llegoNavegacion($event)"></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer style="background: #bfd0c0;" class="mt-2">

    <div class="container">

        <div class="text-center">
            <img src="./assets/images/footer/sello-ust_Mesa_de_trabajo_1.svg" alt="" class="flogo img-fluid mt-3 mb-2" style="border-left:none; max-height: 60px;">
        </div>

    </div>
    <div class="row" style="height: 30px; background-color:#003b30" class="text-center">
        <p style="color: white; font-family: Roboto,sans-serif;" class="pt-2 mb-2">Derechos reservados Santo Tomás. Casa Central AV. Ejército 146, Barrio Universitario, Santiago.</p>
    </div>
</footer>